const klaroAddBtn = (btn) => {
    let newBtn = btn.cloneNode(true)
    let settingsBtn = document.querySelector('#klaro .cn-body>p>a').cloneNode(true)
    settingsBtn.addEventListener('click', function (e) {
        klaro.show()
    })
    btn.parentNode.insertBefore(settingsBtn, btn)
	document.querySelector('.cn-decline').remove()


	btn.parentNode.insertBefore(newBtn, btn)
	btn.remove()

	newBtn.addEventListener('click', function (e) {
		klaro.show()
		document.querySelector('#klaro').style.display = 'none'
		document.querySelector('#app-item-disableAll').click()
		window.setTimeout(function () {
			document.querySelector('#klaro .cm-footer button').click()
			document.querySelector('#klaro').remove()
		}, 100)
	})
}

export { klaroAddBtn }